// extracted by mini-css-extract-plugin
export default {"formContainer":"Adminform_formContainer__8F0zu","form":"Adminform_form__DQd4r","preview":"Adminform_preview__5WQyo"};